import { render, staticRenderFns } from "./OccupancyOverviewTable.vue?vue&type=template&id=546282a8&"
import script from "./OccupancyOverviewTable.vue?vue&type=script&lang=js&"
export * from "./OccupancyOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./OccupancyOverviewTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports